module.exports = __webpack_public_path__ + "img/icon_bj.1820a461.png";